module.exports = __webpack_public_path__ + "static/policescorecard-cdc59f462728bedf28651a9f9715e191.png";